import { UIKitTheme } from 'ui/themes/getUIKitTheme'

export const getFocusBgColor = (theme: UIKitTheme, overColoredPad = false) => {
  if (overColoredPad) {
    return theme.uiKit.colors.global.general.main
  }
  return theme.uiKit.colors.theme.brand.primary
}
